import ManageChoiceGroupTable from "./ManageChoiceGroupTable";
import { Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

const ManageChoiceGroup = () => {
  const { t, i18n } = useTranslation();
  const [, forceUpdate] = useState({});

  // Force re-render when language changes
  useEffect(() => {
    const handleLanguageChange = () => {
      forceUpdate({});
    };

    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return (
   <>
      <>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          {t('choiceGroup.title')}
        </Typography>
        <ManageChoiceGroupTable/>
      </>
  </>
  );
};

export default ManageChoiceGroup;
